import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fitnastic_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function streamPost(path, body, { onDelta, onDone, onError } = {}) {
  try {
    const token = localStorage.getItem("fitnastic_admin_token");
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      onError && onError(res.status);
      return;
    }
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    for (;;) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const payload = line.slice(5).trim();
        if (payload === "[DONE]") {
          onDone && onDone();
          return;
        }
        try {
          onDelta && onDelta(JSON.parse(payload).t);
        } catch {}
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError(e);
  }
}

export function loadRazorpay() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const s = document.createElement("script");
    s.src = "https://checkout.razorpay.com/v1/checkout.js";
    s.onload = () => resolve(true);
    s.onerror = () => resolve(false);
    document.body.appendChild(s);
  });
}

export async function startPayment({ type, admissionId, itemName, prefill = {}, onSuccess, onError }) {
  try {
    const loaded = await loadRazorpay();
    if (!loaded) {
      onError && onError("Could not load payment gateway");
      return;
    }
    const { data } = await api.post("/payments/order", {
      type,
      admission_id: admissionId || null,
      item_name: itemName || null,
    });
    const rzp = new window.Razorpay({
      key: data.key_id,
      amount: data.amount * 100,
      currency: "INR",
      name: "Fitnastic Gym",
      description: data.description,
      order_id: data.order_id,
      prefill,
      theme: { color: "#FFE600" },
      handler: async (resp) => {
        try {
          await api.post("/payments/verify", {
            payment_db_id: data.payment_db_id,
            razorpay_order_id: resp.razorpay_order_id,
            razorpay_payment_id: resp.razorpay_payment_id,
            razorpay_signature: resp.razorpay_signature,
          });
          onSuccess && onSuccess();
        } catch (e) {
          onError && onError(e);
        }
      },
    });
    rzp.on("payment.failed", () => onError && onError("failed"));
    rzp.open();
  } catch (e) {
    onError && onError(e);
  }
}

export default api;
